<template>
  <div
    class="pages"
    style="display: flex; flex-direction: column; align-items: center;"
  >
    <div id="nav">
      <router-link to="/">LoginPage</router-link> |
      <router-link to="/dashboard">DashboardPage</router-link> |
      <router-link to="/conditions">ConditionsPage</router-link> |
      <router-link to="/limits">LimitsPage</router-link> |
      <router-link to="/passcode">PassCodePage</router-link> |
      <router-link to="/report">ReportPage</router-link> |
      <router-link to="/successful">SuccessfulPage</router-link> |
      <router-link to="/profileEdit">ProfileEditPage</router-link> |
      <router-link to="/myBonusesPage">BonusesPage</router-link> |
    </div>
    <router-view />
    <div class="notification">
      <h1>
        If you find yourself here, most likely, the page you wanted to go to is
        under development
      </h1>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  name: "Pages"
};
</script>
